import { axiosInstance, axiosInstanceConfig } from "./config";

export const profiles_req = async () => {
  const response = await axiosInstanceConfig.get(`api/v1/profiles`);

  return response?.data;
};

export const profilesIdTopics_req = async id => {
  const response = await axiosInstanceConfig.get(`api/v1/profiles/${id}/topics`);

  return response?.data;
};

export const profilesIdTopicsQuestions_req = async (id, topicId) => {
  const response = await axiosInstanceConfig.get(`api/v1/profiles/${id}/topics/${topicId}/questions`);

  return response?.data;
};
export const topicAnswered_req = async (id, topicId, answers) => {
  const response = await axiosInstanceConfig.post(`api/v1/profiles/${id}/topics/${topicId}/answers`, {
    answers,
  });

  return response?.data;
};

export const userActivity_req = async (sessionId, time, action) => {
  const session_id = sessionId;
  const time_spent = time;
  const actions = [action];
  const response = await axiosInstanceConfig.post(`api/v1/users_activity/track`, { session_id, time_spent, actions });

  return response;
};

export const forgotPassword_req = async email => {
  const user = {
    email,
  };
  const response = await axiosInstance.post(`api/v1/password`, { user });
  return response?.data;
};

export const changePassword_req = async (data, reset_password_token) => {
  const user = {
    password: data?.password,
    password_confirmation: data?.password_confirmation,
    reset_password_token,
    // only_check: true,
  };
  const response = await axiosInstance.put(`api/v1/password`, { user });
  return response?.data;
};
